module.exports = __webpack_public_path__ + "img/a09de50.jpg";